function createOrrisAnalytics(products, publish, privacy, pathname, debug = false) {
  const catalog = new Map(products.map(p => [p.slug, p]));
  const events = new Set(['product_view', 'product_select', 'bag_add', 'bag_quantity', 'bag_remove', 'bag_view']);
  const aliases = {'/product.html':'beef-liver', '/pages/the-first-treat':'beef-liver'};
  const route = String(pathname).replace(/\/$/, '') || '/';
  const slug = aliases[route] || route.replace(/^\/pages\//, '').replace(/^\//, '').replace(/\.html$/, '');
  const pageKey = catalog.has(slug) ? slug : /treats/.test(route) ? 'treats' : /our-story|about/.test(route) ? 'our-approach' : route === '/' || /index\.html$/.test(route) ? 'home' : 'other';
  const pagePath = pageKey === 'home' ? '/' : pageKey === 'our-approach' ? '/pages/our-story' : pageKey === 'other' ? '/' : '/pages/' + pageKey;
  return {
    allowed() { try { return privacy() === true; } catch (_) { return false; } },
    track(name, itemSlug, details = {}) {
      if (!events.has(name) || !this.allowed()) return false;
      const product = catalog.get(itemSlug);
      if (name !== 'bag_view' && !product) return false;
      const payload = {commerce_mode:'preview', page_key:pageKey, page_location:'https://orrisdog.com' + pagePath};
      if (product) { payload.item_id = product.slug; payload.item_name = product.name; }
      for (const key of ['quantity', 'previous_quantity', 'bag_count']) {
        const value = details[key];
        const limit = key === 'bag_count' ? 297 : 99;
        if (Number.isInteger(value) && value >= 0 && value <= limit) payload[key] = value;
      }
      if (['product', 'quick_add', 'bag', 'navigation'].includes(details.source)) payload.action_source = details.source;
      if (debug) payload.debug_mode = true;
      try { publish('orris:' + name, payload); return true; } catch (_) { return false; }
    }
  };
}
if (typeof module !== 'undefined' && module.exports) module.exports = {createOrrisAnalytics};

(() => {
  'use strict';
/* Pure demo-bag state. Never stores prices supplied by a visitor. */
function createOrrisDemoBag(products, storage) {
  const catalog = new Map(products.map(p => [p.slug, p]));
  const key = 'orris.demo-bag.v2';
  const quantity = value => Math.min(99, Math.max(1, Math.trunc(Number(value)) || 1));
  let items = [];
  function save() { try { storage.setItem(key, JSON.stringify({version: 2, items})); } catch (_) {} }
  try {
    const saved = JSON.parse(storage.getItem(key));
    if (saved?.version === 2 && Array.isArray(saved.items)) {
      for (const item of saved.items) {
        if (!item || !catalog.has(item.slug) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99) continue;
        const existing = items.find(i => i.slug === item.slug);
        if (existing) existing.quantity = quantity(existing.quantity + item.quantity);
        else items.push({slug: item.slug, quantity: item.quantity});
      }
    }
  } catch (_) {}
  save();
  return {
    quantity,
    entries: () => items.map(item => ({...catalog.get(item.slug), quantity: item.quantity})),
    count: () => items.reduce((sum, item) => sum + item.quantity, 0),
    subtotal: () => items.reduce((sum, item) => sum + item.quantity * catalog.get(item.slug).demoPriceCents, 0),
    add(slug, value) {
      if (!catalog.has(slug)) return false;
      const existing = items.find(item => item.slug === slug);
      if (existing) existing.quantity = quantity(existing.quantity + quantity(value));
      else items.push({slug, quantity: quantity(value)});
      save(); return true;
    },
    set(slug, value) { const item = items.find(i => i.slug === slug); if (item) { item.quantity = quantity(value); save(); } },
    remove(slug) { items = items.filter(item => item.slug !== slug); save(); }
  };
}

  const data = document.getElementById('orris-demo-products');
  let products = [];
  try { products = JSON.parse(data?.textContent || '[]'); } catch (_) {}
  let storage;
  try { storage = window.sessionStorage; } catch (_) { storage = {getItem: () => null, setItem() {}}; }
  const bag = createOrrisDemoBag(products, storage);
  const tracker = createOrrisAnalytics(products,
    (name, payload) => window.Shopify.analytics.publish(name, payload),
    () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.Shopify?.analytics?.publish === 'function',
    window.location.pathname, new URLSearchParams(window.location.search).get('orris_debug') === '1');
  const currentProduct = document.querySelector('[data-product-id]')?.dataset.productId;
  let productViewSent = false;
  function trackProductView() {
    if (currentProduct && !productViewSent) productViewSent = tracker.track('product_view', currentProduct);
  }
  let privacyLoading = false;
  function loadPrivacyApi() {
    if (window.Shopify?.customerPrivacy || privacyLoading || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyLoading = true;
    window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => {
      privacyLoading = false;
      if (!error) trackProductView();
    });
  }
  loadPrivacyApi();
  trackProductView();
  document.addEventListener('visitorConsentCollected', trackProductView);
  let trackerAttempts = 0;
  const trackerReady = window.setInterval(() => {
    loadPrivacyApi();
    trackProductView();
    if (++trackerAttempts >= 20 || productViewSent || !currentProduct) window.clearInterval(trackerReady);
  }, 250);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-product-select]');
    if (link) tracker.track('product_select', link.dataset.productSelect, {source:'navigation'});
  });
  const drawer = document.getElementById('demo-bag');
  const bagItems = drawer?.querySelector('[data-bag-items]');
  const subtotal = drawer?.querySelector('[data-bag-subtotal]');
  const status = document.querySelector('[data-bag-status]');
  const catalogUrl = document.querySelector('.primary-nav a[href*="treats"]')?.href || '/pages/treats';
  let bagOpener = null;
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents / 100);
  const safe = text => String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function announce(message) { if (status) status.textContent = message; }
  function renderBag(focusKey) {
    document.querySelectorAll('[data-bag-count]').forEach(el => el.textContent = bag.count());
    if (!bagItems) return;
    const entries = bag.entries();
    bagItems.innerHTML = entries.length ? entries.map(p => `<article class="cart-item">
      <a href="${safe(p.href)}" tabindex="-1" aria-hidden="true"><img src="${safe(p.image)}" alt="" width="102" height="122"></a>
      <div><strong><a href="${safe(p.href)}">${safe(p.name)}</a></strong><p class="demo-item-price">${money(p.demoPriceCents)} / pouch</p>
      <div class="cart-item-actions"><div class="cart-stepper"><button type="button" data-bag-change="${p.slug}" data-delta="-1" data-focus-key="${p.slug}-minus" aria-label="Decrease ${safe(p.name)} quantity" ${p.quantity===1?'disabled':''}>−</button><input type="number" min="1" max="99" step="1" value="${p.quantity}" data-bag-quantity="${p.slug}" data-focus-key="${p.slug}-quantity" aria-label="${safe(p.name)} quantity"><button type="button" data-bag-change="${p.slug}" data-delta="1" data-focus-key="${p.slug}-plus" aria-label="Increase ${safe(p.name)} quantity" ${p.quantity===99?'disabled':''}>+</button></div><button class="remove-item" type="button" data-bag-remove="${p.slug}" aria-label="Remove ${safe(p.name)}">Remove</button></div><p class="item-total">Line total: ${money(p.quantity*p.demoPriceCents)}</p></div></article>`).join('') : `<div class="empty-bag"><p>Your bag is empty.</p><p>Explore the range and add a treat to compare.</p><a class="button button-outline" href="${safe(catalogUrl)}">Explore treats</a></div>`;
    if (subtotal) subtotal.textContent = money(bag.subtotal());
    if (focusKey) {
      const target = bagItems.querySelector(`[data-focus-key="${focusKey}"]`);
      (target && !target.disabled ? target : bagItems.querySelector('[data-bag-quantity]') || drawer.querySelector('[data-close-bag]'))?.focus();
    }
  }
  function openBag(opener) {
    if (!drawer) return;
    closeMenu();
    if (zoom?.open) zoom.close();
    bagOpener = opener;
    renderBag();
    if (!drawer.open) { drawer.showModal(); tracker.track('bag_view', null, {bag_count:bag.count(), source:'bag'}); }
    drawer.querySelector('[data-close-bag]')?.focus();
  }
  document.querySelectorAll('[data-open-bag]').forEach(button => button.addEventListener('click', () => openBag(button)));
  document.querySelectorAll('[data-demo-add]').forEach(button => button.addEventListener('click', () => {
    const slug = button.dataset.demoAdd;
    const previous = bag.entries().find(p => p.slug === slug)?.quantity || 0;
    if (bag.add(slug, 1)) {
      const actual = bag.entries().find(p => p.slug === slug).quantity - previous;
      if (actual > 0) tracker.track('bag_add', slug, {quantity:actual, source:'quick_add'});
      announce('Added to bag. Checkout is unavailable.'); openBag(button);
    }
  }));
  document.querySelectorAll('[data-demo-form]').forEach(form => {
    const input = form.querySelector('[name="quantity"]');
    input?.addEventListener('change', () => { input.value = bag.quantity(input.value); });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const value = bag.quantity(input?.value);
      if (input) input.value = value;
      const slug = form.dataset.demoForm;
      const previous = bag.entries().find(p => p.slug === slug)?.quantity || 0;
      if (bag.add(slug, value)) {
        const actual = bag.entries().find(p => p.slug === slug).quantity - previous;
        if (actual > 0) tracker.track('bag_add', slug, {quantity:actual, source:'product'});
        announce(`Added ${actual} to bag. Checkout is unavailable.`); openBag(form.querySelector('[type="submit"]'));
      }
    });
  });
  drawer?.addEventListener('click', event => {
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
      return;
    }
    if (event.target.closest('[data-close-bag]')) { drawer.close(); return; }
    const change = event.target.closest('[data-bag-change]');
    const remove = event.target.closest('[data-bag-remove]');
    if (change) {
      const item = bag.entries().find(p => p.slug === change.dataset.bagChange);
      if (item) {
        bag.set(item.slug, item.quantity+Number(change.dataset.delta));
        const updated = bag.entries().find(p => p.slug === item.slug).quantity;
        if (updated !== item.quantity) tracker.track('bag_quantity', item.slug, {quantity:updated, previous_quantity:item.quantity, source:'bag'});
      }
      renderBag(change.dataset.focusKey); announce('Bag updated.');
    }
    if (remove) {
      const item = bag.entries().find(p => p.slug === remove.dataset.bagRemove);
      bag.remove(remove.dataset.bagRemove);
      if (item) tracker.track('bag_remove', item.slug, {quantity:item.quantity, source:'bag'});
      renderBag('removed'); announce('Item removed from bag.');
    }
  });
  drawer?.addEventListener('change', event => {
    const input = event.target.closest('[data-bag-quantity]');
    if (input) {
      const item = bag.entries().find(p => p.slug === input.dataset.bagQuantity);
      bag.set(input.dataset.bagQuantity, input.value);
      const updated = bag.entries().find(p => p.slug === input.dataset.bagQuantity)?.quantity;
      if (item && updated !== item.quantity) tracker.track('bag_quantity', item.slug, {quantity:updated, previous_quantity:item.quantity, source:'bag'});
      renderBag(input.dataset.focusKey); announce('Bag updated.');
    }
  });
  drawer?.addEventListener('close', () => bagOpener?.focus());
  renderBag();

  const gallery = document.querySelector('[data-gallery]');
  const mainImage = gallery?.querySelector('[data-gallery-main]');
  const mainButton = gallery?.querySelector('[data-gallery-zoom]');
  const caption = gallery?.querySelector('[data-gallery-caption]');
  const thumbs = Array.from(gallery?.querySelectorAll('[data-gallery-thumb]') || []);
  const zoom = document.getElementById('gallery-dialog');
  const zoomImage = zoom?.querySelector('[data-zoom-image]');
  const zoomCaption = zoom?.querySelector('[data-zoom-caption]');
  let currentThumb = thumbs[0] || null;

  function selectImage(thumb) {
    if (!thumb || !mainImage) return;
    currentThumb = thumb;
    thumbs.forEach(button => {
      const selected = button === thumb;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    mainImage.classList.add('is-swapping');
    mainImage.src = thumb.dataset.src;
    if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
    else mainImage.removeAttribute('srcset');
    mainImage.alt = thumb.dataset.alt || '';
    mainButton?.setAttribute('aria-label', `Enlarge ${thumb.getAttribute('aria-label')?.replace(/^Show /, '') || 'image'}`);
    if (caption) caption.textContent = (thumb.dataset.caption || '').toUpperCase();
    const finish = () => mainImage.classList.remove('is-swapping');
    if (mainImage.complete) finish();
    else { mainImage.addEventListener('load', finish, { once: true }); mainImage.addEventListener('error', finish, { once: true }); }
  }
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => selectImage(thumb));
    thumb.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const next = thumbs[(index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length];
      next.focus(); selectImage(next);
    });
  });
  mainButton?.addEventListener('click', () => {
    if (!zoom || !zoomImage || !currentThumb) return;
    zoomImage.src = currentThumb.dataset.src;
    zoomImage.alt = currentThumb.dataset.alt || '';
    if (zoomCaption) zoomCaption.textContent = currentThumb.dataset.caption || '';
    zoom.showModal();
    zoom.querySelector('[data-close-zoom]')?.focus();
  });
  zoom?.addEventListener('close', () => mainButton?.focus());
  zoom?.querySelector('[data-close-zoom]')?.addEventListener('click', () => zoom.close());
  zoom?.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });

  const header = document.querySelector('[data-header]');
  const path = window.location.pathname;
  const isTreat = /treats|beef-liver|beef-heart|chicken-breast|the-first-treat|product\.html/.test(path);
  document.querySelectorAll('.primary-nav a').forEach(link => {
    const target = new URL(link.href).pathname;
    if (target === path || (isTreat && /treats/.test(target))) link.setAttribute('aria-current', 'page');
  });
  const menuButton = document.querySelector('[data-menu-toggle]');
  function closeMenu() {
    header?.classList.remove('nav-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
  }
  menuButton?.addEventListener('click', () => {
    const open = !header?.classList.contains('nav-open');
    header?.classList.toggle('nav-open', open);
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });
  header?.querySelectorAll('.primary-nav a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && header?.classList.contains('nav-open')) {
      closeMenu(); menuButton?.focus();
    }
  });
  document.addEventListener('click', event => {
    if (header?.classList.contains('nav-open') && !header.contains(event.target)) closeMenu();
  });
  const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const sections = document.querySelectorAll('[data-reveal]');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -30px 0px', threshold: .08 });
    sections.forEach(section => observer.observe(section));
    document.documentElement.classList.add('motion-ready');
  }
})();
